import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=3d2f68fd&scoped=true&"
import script from "./MenuButton.vue?vue&type=script&lang=js&"
export * from "./MenuButton.vue?vue&type=script&lang=js&"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=3d2f68fd&scoped=true&lang=css&"
import style1 from "./MenuButton.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f68fd",
  null
  
)

export default component.exports